export default function Valeurs() {
  const valeurs = [
    {
      icon: 'ri-shield-check-line',
      titre: 'Intégrité',
      description: 'Agir avec honnêteté, transparence et respect des engagements. Prendre des décisions responsables, alignées avec l\'éthique, et assumer pleinement les impacts humains, technologiques et organisationnels des choix posés.'
    },
    {
      icon: 'ri-lightbulb-line',
      titre: 'Clarté',
      description: 'Simplicité dans la communication, précision dans la structuration, accessibilité dans nos systèmes.'
    },
    {
      icon: 'ri-hand-heart-line',
      titre: 'Responsabilité',
      description: 'Conscience de l\'impact de nos technologies sur l\'humain et engagement à servir son développement.'
    },
    {
      icon: 'ri-book-open-line',
      titre: 'Transmission',
      description: 'Partage des connaissances et des pratiques pour permettre l\'autonomie et la croissance collective.'
    },
    {
      icon: 'ri-user-star-line',
      titre: 'Autonomie',
      description: 'Conception de systèmes qui renforcent la capacité d\'action et de décision des individus et des organisations.'
    },
    {
      icon: 'ri-compass-line',
      titre: 'Cohérence',
      description: 'Agir de façon alignée entre la vision, les structures mises en place et l\'impact humain réel. Concevoir des systèmes qui respectent le sens, l\'éthique et la finalité humaine.'
    }
  ];

  return (
    <section id="valeurs" className="bg-[#FAF8F5] py-16 sm:py-24 lg:py-32 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="mb-12 sm:mb-16 lg:mb-20">
          <p className="text-xs sm:text-sm text-gray-500 font-light mb-3 sm:mb-4">NOS VALEURS FONDAMENTALES</p>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
            Ce qui guide chacune
            <br />
            de nos décisions
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {valeurs.map((valeur, index) => (
            <div
              key={index}
              className="bg-white/60 backdrop-blur-sm p-6 sm:p-8 rounded-lg hover:shadow-lg transition-shadow"
            >
              <div className="w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${valeur.icon} text-2xl sm:text-3xl text-gray-900`}></i>
              </div>
              <h3 className="text-lg sm:text-xl font-semibold text-gray-900 mb-3 sm:mb-4">{valeur.titre}</h3>
              <p className="text-sm font-light text-gray-700 leading-relaxed">
                {valeur.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
